<mapp-action-modal
    iconPath="/assets/icons/trash-blue.svg"
    [title]="'Are you sure you want &lt;br> to delete this document?'"
    [primaryButton]="primaryButtonObject"
    [secondaryButton]="secondaryButtonObject"
></mapp-action-modal>
